import '@fancyapps/fancybox';
import '../jquery.serializejson';

$(document).on('click', '[name="nlr-sub"]', function(){
  var error = false;

  if( $.trim($('[id="nlr-sub"] [name="email"]').val()) == '' ){
    $('[id="nlr-sub"] [name="email"]').parents('.form-group').addClass('input-error');
    error = true;
  }
  if( $.trim($('[id="nlr-sub"] [name="firstname"]').val()) == '' ){
    $('[id="nlr-sub"] [name="firstname"]').parents('.form-group').addClass('input-error');
    error = true;
  }
  if( $.trim($('[id="nlr-sub"] [name="lastname"]').val()) == '' ){
    $('[id="nlr-sub"] [name="lastname"]').parents('.form-group').addClass('input-error');
    error = true;
  }

  if( error ){
    $('[id="nlr-sub"] .form-group.input-error input').eq(0).focus();
  }else{
    var oldpopup = $('.fancybox-container');
    var indexed_array = $('#nlr-sub').serializeJSON();

    $.fancybox.open({
      src: '/popup-newsletter/',
      type: 'ajax',
      parentEl: 'body',
      margin: [50, 0],
      lang: 'fr',
      i18n: {
        fr: {
          CLOSE: 'Fermer',
          NEXT: 'Prochain',
          PREV: 'Précédent',
          ERROR: 'Le contenu demandé ne peut pas être chargé. <br/> Veuillez réessayer plus tard.',
          PLAY_START: 'Lancer le diaporama',
          PLAY_STOP: 'Suspendre le diaporama',
          FULL_SCREEN: 'Plein écran',
          THUMBS: 'Vignettes',
          DOWNLOAD: 'Télécharger',
          SHARE: 'Partager',
          ZOOM: 'Zoom',
        },
      },
      ajax: {
        settings: {
          data: indexed_array,
          type: 'post'
        }
      },
      afterShow: function(){
        oldpopup.each(function(){
          $(this).remove();
        });
      }
    });
  }

  return false;
});
